import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgLogoFlat = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 72 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill='#40286F'
      d='M17.862 18.468q.915.485 2.296.485c1.525 0 3.11.04 4.565-.466q.318-.225.822-.99.522-.765.914-1.568.41-.821.41-1.213V6.073l-.56-.466-4.012.522.186 8.904q-.167.075-.71.131-.537.056-.966.056h-.369q-.747 0-1.064-.28-.3-.3-.336-.877l-.187-2.894-.466-.56a55 55 0 0 1-4.443-.41 28 28 0 0 1-.953-.146 42 42 0 0 0 1.662-.47q2.165-.672 3.734-1.456l-1.083-3.174-.747-.186q-1.194.672-3.49 1.53a45 45 0 0 1-4.63 1.419l-.28 4.237q.654.524 2.483.99 1.848.466 3.64.597v1.723a37 37 0 0 1-1.923.162q-1.455.075-2.744.075-1.437 0-2.146-.15-.71-.149-.952-.503-.243-.355-.187-1.027l.205-2.427-3.546-.466-.654.373a37 37 0 0 0-.336 2.128q-.13 1.008-.13 1.605 0 1.475.765 2.408.765.915 2.352 1.363 1.605.43 4.163.43 2.128 0 4.162-.225 2.054-.224 3.155-.522a7 7 0 0 0 .526-.73q.337.426.874.711'
    />
    <path
      fill='url(#logo-flat_svg__a)'
      d='M17.862 18.468q.915.485 2.296.485c1.525 0 3.11.04 4.565-.466q.318-.225.822-.99.522-.765.914-1.568.41-.821.41-1.213V6.073l-.56-.466-4.012.522.186 8.904q-.167.075-.71.131-.537.056-.966.056h-.369q-.747 0-1.064-.28-.3-.3-.336-.877l-.187-2.894-.466-.56a55 55 0 0 1-4.443-.41 28 28 0 0 1-.953-.146 42 42 0 0 0 1.662-.47q2.165-.672 3.734-1.456l-1.083-3.174-.747-.186q-1.194.672-3.49 1.53a45 45 0 0 1-4.63 1.419l-.28 4.237q.654.524 2.483.99 1.848.466 3.64.597v1.723a37 37 0 0 1-1.923.162q-1.455.075-2.744.075-1.437 0-2.146-.15-.71-.149-.952-.503-.243-.355-.187-1.027l.205-2.427-3.546-.466-.654.373a37 37 0 0 0-.336 2.128q-.13 1.008-.13 1.605 0 1.475.765 2.408.765.915 2.352 1.363 1.605.43 4.163.43 2.128 0 4.162-.225 2.054-.224 3.155-.522a7 7 0 0 0 .526-.73q.337.426.874.711'
      style={{
        mixBlendMode: 'overlay',
      }}
    />
    <path
      fill='#40286F'
      fillRule='evenodd'
      d='M30.213 18.505q.99.448 2.632.448h1.4q1.232 0 2.034-.317a2.74 2.74 0 0 0 1.108-.8q.15.189.33.352 1.064.952 2.874.952.934 0 2.128-.205 1.215-.224 1.792-.486.3-.336.672-1.008.393-.672.672-1.344.28-.672.28-.97 0-.598-.261-2.464-.242-1.886-.392-2.39l-.56-.466q-1.474.168-3.79.168-2.313 0-3.826-.168l-.541.466-.747 3.08q-.206.785-.41 1.176-.206.393-.523.542-.3.15-.84.149h-.56q-.465 0-.709-.224-.224-.243-.224-.71V6.074l-.56-.466-4.013.466.093 8.494q.019 1.55.485 2.52a3 3 0 0 0 1.456 1.418m10.677-5.002q.411 0 .672-.056l.093 1.866q-.204.037-.466.075a7 7 0 0 1-.504.019q-.355 0-.542-.15-.168-.168-.168-.504 0-.206.056-.597a8 8 0 0 1 .168-.71q.3.057.691.057'
      clipRule='evenodd'
    />
    <path
      fill='url(#logo-flat_svg__b)'
      fillRule='evenodd'
      d='M30.213 18.505q.99.448 2.632.448h1.4q1.232 0 2.034-.317a2.74 2.74 0 0 0 1.108-.8q.15.189.33.352 1.064.952 2.874.952.934 0 2.128-.205 1.215-.224 1.792-.486.3-.336.672-1.008.393-.672.672-1.344.28-.672.28-.97 0-.598-.261-2.464-.242-1.886-.392-2.39l-.56-.466q-1.474.168-3.79.168-2.313 0-3.826-.168l-.541.466-.747 3.08q-.206.785-.41 1.176-.206.393-.523.542-.3.15-.84.149h-.56q-.465 0-.709-.224-.224-.243-.224-.71V6.074l-.56-.466-4.013.466.093 8.494q.019 1.55.485 2.52a3 3 0 0 0 1.456 1.418m10.677-5.002q.411 0 .672-.056l.093 1.866q-.204.037-.466.075a7 7 0 0 1-.504.019q-.355 0-.542-.15-.168-.168-.168-.504 0-.206.056-.597a8 8 0 0 1 .168-.71q.3.057.691.057'
      clipRule='evenodd'
      style={{
        mixBlendMode: 'overlay',
      }}
    />
    <path
      fill='#40286F'
      fillRule='evenodd'
      d='M62 1.155a4 4 0 0 0-4 0l-6.392 3.69a4 4 0 0 0-2 3.464v7.382a4 4 0 0 0 2 3.464L58 22.845a4 4 0 0 0 4 0l6.392-3.69a4 4 0 0 0 2-3.464V8.309a4 4 0 0 0-2-3.464zM63.464 6a6.928 6.928 0 1 0-6.928 12 6.928 6.928 0 0 0 6.928-12'
      clipRule='evenodd'
    />
    <path
      fill='url(#logo-flat_svg__c)'
      fillRule='evenodd'
      d='M62 1.155a4 4 0 0 0-4 0l-6.392 3.69a4 4 0 0 0-2 3.464v7.382a4 4 0 0 0 2 3.464L58 22.845a4 4 0 0 0 4 0l6.392-3.69a4 4 0 0 0 2-3.464V8.309a4 4 0 0 0-2-3.464zM63.464 6a6.928 6.928 0 1 0-6.928 12 6.928 6.928 0 0 0 6.928-12'
      clipRule='evenodd'
      style={{
        mixBlendMode: 'overlay',
      }}
    />
    <defs>
      <linearGradient
        id='logo-flat_svg__a'
        x1={23.647}
        x2={23.647}
        y1={0.287}
        y2={28.287}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#fff' />
        <stop offset={1} stopColor='#fff' stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id='logo-flat_svg__b'
        x1={23.647}
        x2={23.647}
        y1={0.287}
        y2={28.287}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#fff' />
        <stop offset={1} stopColor='#fff' stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id='logo-flat_svg__c'
        x1={59.834}
        x2={59.834}
        y1={-6.43}
        y2={37.626}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#fff' />
        <stop offset={1} stopColor='#fff' stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgLogoFlat)
export default ForwardRef
